import AdvanceSearchContextProviderTest from "./AdvanceSearchContextTest";
import InterviewAdvanceSearchTest from "./InterviewAdvanceSearchTest";

export default function InterviewAdvanceSearchPageTest() {
  return (
    <AdvanceSearchContextProviderTest>
      <InterviewAdvanceSearchTest />
    </AdvanceSearchContextProviderTest>
  );
}
